import "./footer.css";

const Footer: React.FC = () => {
  return (
    <div className="Footer">
      <div className="Footer-Content">
        <img src="./museum-logo.svg" />
        <img src="./logomodsen-02.png" />
      </div>
    </div>
  );
};

export default Footer;
